import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dg7nau6taf: FaireBrandEntity = {
  token: "b_dg7nau6taf",
  type: "brand",
  name: "Loralin Design",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff287f30d52210ef64fdc10290852b252855d1557b42bf6d4a047196b4a3e762.jpeg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/7866a0d1b877c0926227d94fb79eaedb754d70038be03b766610f89b162c113b/1555026956.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ff287f30d52210ef64fdc10290852b252855d1557b42bf6d4a047196b4a3e762.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/7866a0d1b877c0926227d94fb79eaedb754d70038be03b766610f89b162c113b/1555026956.png",
  location: "Yardley, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 30,
  isInsider: true,
  description:
    "Lynne Buchman is the designer behind Loralin Design, a company whose first product, A Parent’s Journal for the Babysitter, was hailed by The London Times as “Idea of the Week” and selected as a “Best Bet” by the editor of New York Magazine. Loralin Design, which began with a single product developed out of the desire to be a more attentive auntie to her adorable nephews, has since evolved to include a wide range of gifts including cotton knits, handmade gift-sets, soft-knit animals and engraved silver keepsakes. Customers are drawn to Buchman’s simple forms, innovative colors, and clever packaging. New moms love both the design and smart function. Most baby and kid items are used for a limited time, but Lynne strives to create timeless keepsakes you’ll want to pass on to the next generation.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:37.616Z",
    importedBy: "entity-db-cli",
  },
};
